import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const TumblrLogo = ({
  color = "#35465D",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Tumblr Logo</title>
    <circle cx={64} cy={64} r={64} fill="currentColor" />
    <path
      fill="#FFF"
      d="M81.229 85.509c-1.339.642-3.9 1.195-5.81 1.248-5.764.154-6.881-4.048-6.929-7.104V57.241h14.457V46.344H68.542V28H57.996c-.175 0-.477.155-.52.538-.617 5.617-3.243 15.469-14.168 19.406v9.298h7.287v23.53c0 8.049 5.942 19.491 21.627 19.224 5.291-.092 11.167-2.307 12.469-4.218l-3.462-10.269"
    />
  </Icon>
);

export default TumblrLogo;
